import {post} from '@/utils/request';
import {erpserver,oaserver} from '@/utils/baseUrl';

//获取交易公司
export async function getCompanyList(params) {
    return post(oaserver+'/oacurrency/getCompanyList', params, true);
}
//待处理联系单列表接口
export async function getLxdList(params) {
    return post(oaserver+'/oatd/getLxdList',params,true)
}
//已打单列表接口
export async function listTd(params) {
   // return post(oaserver+'/oatd/listTd',params,true)
    return post(oaserver+'/oatd/listErpTd',params,true)
}
//编辑提单
export async function editTd(params) {
    return post(oaserver+'/oatd/editTd', params, true);
}
//获取提单详情
export async function getTdDetail(params) {
    return post(oaserver+'/oatd/getTdDetail', params, true);
}
//获取联系单详情
export async function getLxdDetail(params) {
    return post(oaserver+'/oalxd/getLxdDetail', params, true);
}
//获取提货单位列表
export async function getThDw(params) {
    return post(oaserver+'/oacurrency/getThDw', params, true);
}
//确认打单
export async function saveTd(params) {
    return post(oaserver+'/oatd/saveTd', params, true);
}
//{{$t('saleOrder_confirm_audit')}}
export async function approveTempLxd(params) {
    return post(oaserver+'/templxd/approveTempLxd', params, true);
}

